import { IAutomationObject } from '../../types'

export interface IBacnetDevice extends IAutomationObject {
    modelName: string;
    protocolVersion: number;
    protocolRevision: number;
    vendorName: string;
    systemStatus: BacnetDeviceStatus;
    nonOperational: boolean;
    noConnection: boolean;
    deviceId: number;
    usedObjects: number;
    totalObjects: number;
    startupState: StartupState;
    invalidLocalTime: boolean;
    localDate: any;
    uTCOffset?: number;
    isDaylightSaving: boolean
    ipAddress: string | undefined,
    routedSource: string | undefined
    timeout: number | undefined,
    timeDiffInMintes: number,
    enableAutomaticTimeSync: boolean,
    servicesSupported: any
}

export const schema = 'AutomationApps.Devices.BacnetDevice';


export enum BacnetDeviceStatus {
    OPERATIONAL = 0,
    OPERATIONAL_READONLY = 1,
    DOWNLOAD_REQUIRED = 2,
    DOWNLOAD_IN_PROGRESS = 3,
    NON_OPERATIONAL = 4,
    BACKUP_IN_PROGRESS = 5
}

export enum StartupState {
    Offline,
    Initialized,
    ReadObjectList,
    ReadPropertiesOnce,
    SubscribeCov,
    SubscribeCovProperties,
    Running,
    Error
}

export type RoutedSource = {
    Type: string | undefined
    Network: number | undefined
    Address: number[] | undefined
}